module.exports = "precision highp float;\n#define GLSLIFY 1\nuniform sampler2D source;\nuniform sampler2D velocity;\nuniform float dt;\nuniform float scale;\nuniform vec2 px1;\nvarying vec2 uv;\n\nvoid main(){\n    gl_FragColor = texture2D(source, uv-texture2D(velocity, uv).xy*dt*px1)*scale;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/advect.frag
// module id = 304
// module chunks = 0